module.exports = __webpack_public_path__ + "img/Dark-nobg-nobrdr.66b91edb.png";